import { Box, Container, Typography } from "@mui/material";
import React from "react";
import pastLife from "../../images/pastLife.png";


const styles = {
  parenBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "40px",
  },
  leftBox: {
    display: "flex",
    alignItems: "start",
    justifyContent: "center",
    flexDirection: "column",
    gap: 3,
  },
  rightBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  heroTitle: {
    fontFamily: "poppins",
    fontWeight: "bold",
    lineHeight: 1.5,
    opacity: 0.7,
  },
  heroSubtitle: {
    fontFamily: "poppins",
    fontWeight: 600,    
    opacity: 0.7,
  },
  button: {
    px: "10px",
    py: "5px",
    fontFamily: "poppins",
    fontSize: "14px",
    textTransform: "none",
    backgroundColor: "#141414FF",
    color: "#ffffff",
  },
};

const PrivateHero = () => {

  return (
    <Container maxWidth="lg">
      <Box sx={{ ...styles.parenBox }}>
        <Box sx={{ ...styles.leftBox }}>
          <Typography
            variant="h4"
            textAlign={"start"}
            sx={{ ...styles.heroTitle }}
          >
            Private Hypnotherapy & <br />
            Past Life Regression Sessions
          </Typography>
          <Typography
            variant="body1"
            textAlign="start"
            sx={{ ...styles.heroSubtitle }}
          >
            Are you ready to overcome stress, anxiety, or emotional challenges?
            Our professional, private in-person hypnotherapy and past life
            regression sessions are designed to help you access your
            subconscious mind, uncover the root causes of your challenges, and
            achieve lasting clarity and healing.
          </Typography>
         
        </Box>

        <Box sx={{ ...styles.rightBox }}>
          <Box
            component="img"
            src={pastLife}
            sx={{ width: "500px", heigh: "500px",borderRadius:"50px" }}
          />
        </Box>
      </Box>
    </Container>
  );
};

export default PrivateHero;
